/* eslint-disable no-useless-escape */
import { EMAIL } from './messages';
import { emailRegex } from '../constants';

const emailValidation = (fields, key, criteria) => {
  const field = fields[key];
  const message = criteria.message || EMAIL;
  return emailRegex.test(field) ? null : message;
};
export default emailValidation;
